export enum GET_COORDS_ERROR {
  NotReady = 'Функционал получения координат находится в разработке.',
  Common = 'Ошибка определения координат',
  EmptyParams = 'Выбраны точки без координат',
  EmptyDepots = 'Отсутствуют точки с возможностью обновления координат'
}
